export default __webpack_public_path__ + "static/media/cameraLine.73eea0db.svg";